module.exports = __webpack_public_path__ + "media/authors/shawna-newman-square-3b38dbf9.jpg";